// src/locales/en/dropshipping.js
export const dropshipping = {
  // Page titles
  dropshipping: 'Dropshipping',
  settings: 'Dropshipping Settings',
  products: 'Dropshipping Products',
  requests: 'Reseller Requests',
  invoices: 'Dropshipping Invoices',
  invoiceDetail: 'Invoice Detail',

  // Settings page — tabs
  providerSettings: 'Provider Settings',
  resellerSettings: 'Reseller Settings',
  kycDocuments: 'KYC Documents',

  // Provider settings
  enableProvider: 'Enable Provider Mode',
  enableProviderHelp: 'Allow resellers to sell your products through dropshipping',
  listingVisibility: 'Listing Visibility',
  visibilityPublic: 'Public — Anyone can find and apply',
  visibilityUnlisted: 'Unlisted — Only direct-link access',
  visibilityPrivate: 'Private — Hidden from catalog',
  serviceCharge: 'Service Charge (LKR)',
  serviceChargeHelp: 'Charged per delivered order on top of courier charge',
  providerContactPhone: 'Provider Contact Phone',
  allowedPaymentCycles: 'Allowed Payment Cycles',
  paymentCycleHelp: 'Select which payment cycle lengths resellers can choose from',
  days: 'days',

  // Reseller settings
  enableReseller: 'Enable Reseller Mode',
  enableResellerHelp: 'Allow your business to apply to providers and resell their products',
  resellerContactPhone: 'Reseller Contact Phone',
  bankAccount: 'Bank Account',
  selectBank: 'Select Bank',
  selectBranch: 'Select Branch',
  accountName: 'Account Name',
  accountNumber: 'Account Number',

  // KYC
  kycStatus: 'KYC Status',
  kycNotSubmitted: 'Not Submitted',
  kycPending: 'Pending Review',
  kycApproved: 'Approved',
  kycRejected: 'Rejected',
  kycRejectionReason: 'Rejection Reason',
  nicFront: 'NIC Front',
  nicBack: 'NIC Back',
  businessRegImage: 'Business Registration',
  uploadNicFront: 'Upload NIC Front',
  uploadNicBack: 'Upload NIC Back',
  uploadBusinessReg: 'Upload Business Registration',
  kycRequired: 'KYC documents are required when either provider or reseller mode is enabled',
  kycSubmitted: 'KYC documents submitted for review',
  clickToUpload: 'Click to upload',
  orDragDrop: 'or drag and drop',
  fileTypes: 'PNG, JPG, PDF up to 5MB',
  currentFile: 'Current file',
  changeFile: 'Change file',

  // Products page — tabs
  product: 'Product',
  productsTab: 'Products',
  merchantsTab: 'Merchants',

  // Products grid
  searchProducts: 'Search products...',
  filterByMerchant: 'All Merchants',
  filterAssigned: 'Assigned',
  filterUnassigned: 'Unassigned',
  allProducts: 'All',
  dropshippingPrice: 'Dropshipping Price',
  sellingPrice: 'Your Selling Price',
  minSellingPrice: 'Min Selling Price',
  maxSellingPrice: 'Max Selling Price',
  assignProduct: 'Assign',
  unassignProduct: 'Unassign',
  assignedBadge: 'Assigned',
  noProductsFound: 'No products found',
  noProductsDescription: 'No products match your current filters.',
  assignProductTitle: 'Assign Product',
  setSellingPrice: 'Set Selling Price',
  sellingPriceRange: 'Valid range: {{min}} – {{max}}',
  assign: 'Assign',
  updatePrice: 'Update Price',
  updatePriceTitle: 'Update Selling Price',
  priceUpdated: 'Price updated successfully',
  productAssigned: 'Product assigned to your shop',
  productUnassigned: 'Product unassigned',
  confirmUnassign: 'Are you sure you want to unassign this product?',

  // Merchants tab
  viewProducts: 'View Products',
  apply: 'Apply',
  applied: 'Applied',
  approved: 'Approved',
  rejected: 'Rejected',
  connected: 'Connected',
  noMerchantsFound: 'No merchants found',
  noMerchantsDescription: 'No provider merchants are currently available.',
  serviceChargeLabel: 'Service Charge',
  returnPenaltyLabel: 'Return Penalty',

  // Products tab gating messages
  resellerNotEnabled: 'Reseller Mode not enabled',
  resellerNotEnabledHelp: 'Go to Dropshipping Settings and enable Reseller Mode with approved KYC to access the product catalog.',
  noShopsConnected: 'No provider connections yet',
  noShopsConnectedHelp: 'Apply to dropshipping providers in the Merchants tab to start selling their products.',
  viewMerchants: 'Browse Merchants',

  // Apply to provider modal
  applyToProvider: 'Apply to Provider',
  requestedShopName: 'Shop Name',
  requestedShopNamePlaceholder: 'Your shop name on this platform',
  deliveryCharge: 'Delivery Charge (LKR)',
  deliveryChargeHelp: 'Flat delivery charge applied to all shipping zones. Use 0 for free delivery.',
  requestedPaymentCycle: 'Payment Cycle',
  selectPaymentCycle: 'Select payment cycle',
  resellerAccountName: 'Bank Account Name',
  resellerAccountNumber: 'Bank Account Number',
  resellerBank: 'Bank',
  resellerBankBranch: 'Branch',
  submitApplication: 'Submit Application',
  applicationSubmitted: 'Application submitted successfully',
  errorShopNameRequired: 'Shop name is required',
  errorDeliveryChargeRequired: 'Delivery charge is required (use 0 for free delivery)',
  errorDeliveryChargeInvalid: 'Delivery charge must be 0 or a positive number',
  errorAccountNameRequired: 'Bank account name is required',
  errorAccountNumberRequired: 'Bank account number is required',
  errorBankRequired: 'Please select a bank',
  errorBranchRequired: 'Please select a branch',
  errorContactPhoneRequired: 'Contact phone number is required',
  errorNicRequired: 'NIC front and back images are required',
  resellerContactPhonePlaceholder: '+94 77 000 0000',
  kycApprovedLocked: 'KYC is approved and cannot be modified.',
  clickToReplace: 'Click to replace',

  // Requests page
  resellerName: 'Reseller',
  kycStatusCol: 'KYC Status',
  contactPhone: 'Contact Phone',
  requestedDate: 'Requested Date',
  proposedShopName: 'Proposed Shop Name',
  paymentCycleCol: 'Payment Cycle',
  statusCol: 'Status',
  actionsCol: 'Actions',
  approve: 'Approve',
  reject: 'Reject',
  approveRequest: 'Approve Request',
  rejectRequest: 'Reject Request',
  rejectionReason: 'Rejection Reason',
  rejectionReasonPlaceholder: 'Reason for rejecting this application...',
  confirmApprove: 'Are you sure you want to approve this request? A shop will be created for this reseller.',
  requestApproved: 'Request approved — shop created',
  requestRejected: 'Request rejected',
  noRequestsFound: 'No requests found',
  noRequestsDescription: 'No reseller applications have been received.',
  pending: 'Pending',

  // Invoices list
  invoiceNumber: 'Invoice #',
  periodFrom: 'Period From',
  periodTo: 'Period To',
  shopName: 'Shop',
  totalOrders: 'Orders',
  totalAmountPayable: 'Amount Payable',
  status: 'Status',
  generatedAt: 'Generated At',
  searchInvoices: 'Search by invoice number...',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  allStatuses: 'All Statuses',
  allShops: 'All Shops',
  roleProvider: 'As Provider',
  roleReseller: 'As Reseller',
  noInvoicesFound: 'No invoices found',
  noInvoicesDescription: 'No dropshipping invoices match your current filters.',
  generated: 'Generated',
  paid: 'Paid',
  disputed: 'Disputed',
  exportCsv: 'Export CSV',
  viewInvoice: 'View Invoice',
  viewBankDetails: 'View Bank Details',
  bankDetails: 'Bank Account Details',
  unknownShop: 'Unknown Shop',
  resellerAccountName: 'Account Name',
  resellerAccountNumber: 'Account Number',
  bankName: 'Bank',
  bankShortCode: 'Bank Code',
  branchName: 'Branch',
  branchCode: 'Branch Code',
  markAsPaid: 'Mark as Paid',
  clearSelection: 'Clear Selection',
  invoicesSelected: '{{count}} invoice(s) selected',
  confirmMarkPaid: 'Mark {{count}} invoice(s) as paid?',
  invoicesMarkedPaid: '{{count}} invoice(s) marked as paid',

  // Invoice detail
  backToInvoices: 'Back to Invoices',
  invoiceTitle: 'Invoice {{number}}',
  providerBusiness: 'Provider',
  resellerBusiness: 'Reseller',
  period: 'Period',
  generatedDate: 'Generated Date',
  summaryTotals: 'Summary',
  totalDelivered: 'Delivered Orders',
  totalReturned: 'Returned Orders',
  totalCodCollected: 'Total COD Collected',
  totalCourierCharges: 'Courier Charges',
  totalDropshippingCharges: 'Dropshipping Charges',
  totalServiceCharges: 'Service Charges',
  totalReturnPenalties: 'Return Penalties',
  lineItems: 'Line Items',
  airwaybill: 'Airwaybill #',
  deliveryStatus: 'Delivery',
  codAmount: 'COD',
  courierCharge: 'Courier',
  dropshippingCharge: 'Dropshipping',
  serviceCharge: 'Service',
  returnPenalty: 'Return Penalty',
  amountPayable: 'Payable',
  delivered: 'Delivered',
  returned: 'Returned',
  printInvoice: 'Print',
  downloadPdf: 'Download PDF',
  exportLineItemsCsv: 'Export Line Items',
  searchLineItems: 'Search by airwaybill...',
  noLineItemsFound: 'No line items match your search.',
  noLineItems: 'No line items in this invoice.',
  loadingInvoice: 'Loading invoice...',
  failedToLoadInvoice: 'Failed to load invoice',

  // Product form dropshipping fields
  enable: 'Enable',
  bulkEdit: 'Bulk Edit Dropshipping',
  dropshippingPriceRequired: 'Dropshipping price is required when dropshipping is enabled',
  minPriceRequired: 'Minimum selling price is required when dropshipping is enabled',
  maxPriceRequired: 'Maximum selling price is required when dropshipping is enabled',

  // Provider products tab
  dropshippingAllowed: 'Dropshipping Allowed',
  noProviderProducts: 'No products found',
  noProviderProductsDescription: 'No products match your current filters.',
  saveRow: 'Save',

  // Invite link (provider side)
  inviteLink: 'Reseller Invite Link',
  inviteLinkDescription: 'Share this link to invite resellers directly to your dropshipping network',
  generateLink: 'Generate Invite Link',
  regenerateLink: 'Regenerate Link',
  inviteLinkCopied: 'Invite link copied to clipboard',
  regenerateWarning: 'Regenerating will invalidate the current link. Existing resellers already connected will not be affected.',
  copyLink: 'Copy Link',
  inviteLinkLabel: 'Invite URL',

  // Join provider page (public route)
  directJoinTitle: 'Join as Reseller',
  joiningProvider: 'Joining {{providerName}}',
  joinProviderDescription: 'You\'re joining {{providerName}}\'s dropshipping network as a reseller.',
  joinAsReseller: 'Sign up to join as a reseller',
  redirectingToSignup: 'Redirecting to signup...',
  redirectingToProducts: 'Redirecting to products...',
  loadingProviderInfo: 'Loading provider information...',
  invalidInviteLink: 'This invite link is invalid or has expired.',

  // KYC step (reseller onboarding wizard)
  kycUploadTitle: 'Upload KYC Documents',
  kycUploadDescription: 'Please upload the required identity and business documents to complete verification.',

  // Common
  saveSettings: 'Save Settings',
  settingsSaved: 'Settings saved',
  failedToSave: 'Failed to save settings',
  loading: 'Loading...',
  cancel: 'Cancel',
  confirm: 'Confirm',
  role: 'Role',
  close: 'Close',
  viewKyc: 'View KYC',
  noKycImages: 'No KYC documents uploaded.',
};
